import { environment } from '../../../../environments/environment';

export const locationServiceEndpoint = environment.LOCATION_SERVICE_URL || 'http://localhost:3128/location-service';
